import React from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { getHexacoWebSession } from "../../services/hexacoWebApi";

/**
 * Stripe Checkout success_url still points here. Redirect to the order status
 * page, which already shows download / paid state.
 */
const HexacoOrderSuccess: React.FC = () => {
  const [searchParams] = useSearchParams();
  const session = getHexacoWebSession();
  const orderId = searchParams.get("order_id") || session.orderId;
  const target = orderId
    ? `/hexaco/order/${orderId}?fromCheckout=1`
    : "/hexaco/purchase";

  return <Navigate to={target} replace />;
};

export default HexacoOrderSuccess;
